<template>
  <v-content>
    <dark-template-container />
  </v-content>
</template>

<script>
import DarkTemplateContainer from '@/views/dark-template/Container'

export default {
  name      : 'Secure',
  components: { DarkTemplateContainer },
  data () {
    return {}
  },
}
</script>

<style scoped></style>
